import React from 'react'
import { graphql, compose } from 'react-apollo'
import {
  Container,
  Header,
  Body,
  Title,
  Line,
  Close,
  DocumentTypeContainer,
  DocumentTypeButton,
  Signers,
  SignersForm,
  SignerInput,
  SmallText,
  AddSigner,
  Icon,
  BoldText,
  Footer,
  Button,
  RadioInput,
} from '../styles/PrepareEsignModalElements'
import PrepareEsign from '../queries/PrepareEsign'
import HelloSignQuery from '../queries/HelloSignQuery'
import CreateSignatureRequests from '../queries/CreateSignatureRequests'
import FileUploader from '../../common/FileUploader'
import { openEsignModal } from '../helpers/EsignUtil'
// TODO: Don't mutate state. Ever. See methods below.

class PrepareHelloSignModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      documentType: null,
      requestMethod: 'email',
      signers: [{ name: null, email: null, role: null }],
      file: null,
      complete: false,
    }
  }
  componentDidMount() {
    if (this.props.document.helloSignTemplateId) {
      this.setTemplate()
    } else {
      this.setCustom()
    }
  }
  componentWillReceiveProps() {
    this.checkComplete()
  }
  toggleDocumentType = (documentType) => {
    this.setState({ documentType }, this.checkComplete)
  }
  setTemplate = () => {
    const doc = this.props.document
    // Prepopulate form fields
    const signers = doc.helloSignRoles.reduce((arr, role) => {
      const currentSigner = doc.esignSigners.find((s) => {
        return s.role === role.value
      })
      const name = currentSigner ? currentSigner.name : ''
      const email = currentSigner ? currentSigner.email : ''
      arr.push({ name, email, role: role.value, label: role.label })
      return arr
    }, [])
    this.checkForMultipleSigners()
    this.setState(
      {
        documentType: 'template',
        signers,
      },
      this.checkComplete,
    )
  }
  setCustom = () => {
    const { guarantors } = this.props
    // Prepopulate form fields
    const signers = guarantors.reduce((arr, guarantor) => {
      const name = guarantor.name
      const email = guarantor.email
      arr.push({ name, email, role: '', label: '' })
      return arr
    }, [])
    this.checkForMultipleSigners()
    this.setState(
      {
        documentType: 'custom',
        signers,
      },
      this.checkComplete,
    )
  }
  renderDocumentTypeSelection = () => {
    const helloSignTemplateId = this.props.document.helloSignTemplateId
    if (!helloSignTemplateId) {
      return
    }
    return (
      <DocumentTypeContainer>
        <DocumentTypeButton
          active={this.state.documentType === 'template'}
          key="template"
          id="document_type_smartbiz_template"
          onClick={this.setTemplate}
        >
          <RadioInput
            type="radio"
            checked={this.state.documentType === 'template'} // If doc is not adminOnly, it can be seen by borrower
          />
          <Icon
            active={this.state.documentType === 'template'}
            className="fa fa-file-text"
            color="inherit"
          />
          Use a SmartBiz template
        </DocumentTypeButton>
        <DocumentTypeButton
          active={this.state.documentType === 'custom'}
          key="custom"
          id="document_type_custom"
          onClick={this.setCustom}
        >
          <RadioInput
            type="radio"
            checked={this.state.documentType === 'custom'} // If doc is not adminOnly, it can be seen by borrower
          />
          <Icon
            active={this.state.documentType === 'custom'}
            className="fa fa-upload"
            color="inherit"
          />
          Upload a custom document
        </DocumentTypeButton>
      </DocumentTypeContainer>
    )
  }
  renderCustomForm = () => {
    if (this.state.documentType !== 'custom') {
      return
    }
    return <FileUploader uploadDocument={this.uploadDocument} />
  }
  addSigner = () => {
    const signers = this.state.signers
    signers.push({ name: '', email: '', role: '' })
    this.forceUpdate()
  }
  setName = (index, e) => {
    const signers = this.state.signers
    signers[index].name = e.target.value
    this.checkForMultipleSigners()
    this.setState({ signers }, this.checkComplete)
  }
  setEmail = (index, e) => {
    const signers = this.state.signers
    signers[index].email = e.target.value
    this.checkForMultipleSigners()
    this.setState({ signers }, this.checkComplete)
  }
  checkForMultipleSigners = () => {
    const filledSigners = this.state.signers.filter(
      (signer) =>
        signer.name &&
        signer.email &&
        signer.name.length > 0 &&
        signer.email.length > 0,
    )
    if (filledSigners.length > 1) {
      this.setState({ requestMethod: 'email' })
    }
  }
  removeSigner = (index) => {
    const signers = this.state.signers
    if (signers.length == 1) {
      return
    }
    signers.splice(index, 1)
    this.setState({ signers }, this.checkComplete)
  }
  uploadDocument = (file) => {
    this.setState({ file }, this.checkComplete)
  }
  renderSignersForm = () => {
    if (this.state.documentType === null) {
      return
    }
    const { signers, documentType } = this.state
    const filledSigners = signers.filter(
      (signer) =>
        signer.name &&
        signer.email &&
        signer.name.length > 0 &&
        signer.email.length > 0,
    )

    return (
      <Signers>
        <BoldText> Who needs to sign? </BoldText>
        <div>
          {documentType === 'template' && signers.length > 1 && (
            <SmallText size="13px">
              Verify or enter the names of required signers below. Signers can
              be left blank if they aren't relevant.
            </SmallText>
          )}
        </div>
        <div>
          {filledSigners.length > 1 && (
            <SmallText size="13px" color="#CC6900">
              This document will not appear in the borrower application flow
              because there is more than one signer.
            </SmallText>
          )}
        </div>
        <SignersForm ref="signers">
          {/* TODO: Make this a function or another component */}
          {signers.map((signer, index) => (
            <div key={index}>
              {documentType === 'template' && (
                <label>{`${signer.label}`}</label>
              )}
              <SignerInput
                width="200px"
                placeholder="Full Name"
                autoComplete="none"
                type="text"
                name="name"
                value={signer.name || ''}
                onChange={(e) => this.setName(index, e)}
              />
              <SignerInput
                width="300px"
                placeholder="Email"
                autoComplete="none"
                type="text"
                name="email"
                value={signer.email || ''}
                onChange={(e) => this.setEmail(index, e)}
              />
              {this.state.documentType === 'custom' && (
                <span onClick={() => this.removeSigner(index)}>
                  <Icon circleBorder className="fa fa-close" color="#339952" />
                </span>
              )}
            </div>
          ))}
          {this.state.documentType === 'custom' && (
            <AddSigner onClick={() => this.addSigner()}>
              <Icon
                circleBorder
                style={{ marginRight: '10px' }}
                className="fa fa-plus"
                color="#339952"
              />
              Add Signer
            </AddSigner>
          )}
        </SignersForm>
      </Signers>
    )
  }
  checkComplete = () => {
    const { documentType, file, signers, requestMethod } = this.state
    const filledSigners = signers.filter(
      (signer) =>
        signer.name &&
        signer.email &&
        signer.name.length > 0 &&
        signer.email.length > 0,
    )
    if (!requestMethod || signers.length == 0) {
      this.setState({ complete: false })
      return
    }
    if (documentType === 'custom' && !file) {
      this.setState({ complete: false })
      return
    }
    // TODO: Move custom document logic to document.hello_sign_roles?
    if (
      documentType === 'template' &&
      this.props.document.type === 'Document::LandlordSubordination' &&
      filledSigners.length < 2
    ) {
      this.setState({ complete: false })
      return
    }

    if (filledSigners.length > 0) {
      this.setState({ complete: true })
    } else {
      this.setState({ complete: false })
    }
  }
  messageListener = async () => {
    const {
      createSignatureRequests,
      toggleRequestSentModal,
      toggleEsignUrlModal,
    } = this.props
    const requestMethodIsEmail = this.state.requestMethod === 'email'
    await createSignatureRequests({
      variables: {
        documentId: this.props.document.rid,
        sendEmail: requestMethodIsEmail,
      },
    })
    if (requestMethodIsEmail) {
      toggleRequestSentModal()
    } else {
      toggleEsignUrlModal()
    }
  }
  submitEsign = async () => {
    this.setState({ complete: false })
    try {
      const { signers, documentType, requestMethod, file } = this.state
      const filteredSigners = signers.filter(
        (signer) => signer.name !== '' && signer.email !== '',
      )
      const {
        data: {
          prepareEsign: {
            helloSign: { claimUrl },
          },
        },
      } = await this.props.prepareEsign({
        variables: {
          input: {
            signers: filteredSigners,
            documentId: this.props.document.rid,
            documentType,
            requestMethod,
            file,
          },
        },
      })
      this.props.toggleModal()
      openEsignModal(
        this.props.helloSign.helloSign,
        'send',
        this.messageListener,
        claimUrl,
      )
    } catch (err) {
      console.log(err)
    }
  }
  render() {
    const { toggleModal } = this.props
    const { documentType, complete } = this.state
    let instructionText
    let otherInstText
    if (!this.props.document.helloSignTemplateId) {
      instructionText =
        'No standard template is available for this type of document. To use E-Sign, upload a document and manually prepare it to be sent out for signature.'
    } else {
      instructionText =
        "We have a SmartBiz Template for this document, which should work for most cases. If the Template can't be used, select to use a Custom Document."
      otherInstText =
        'Make sure the current lender on the loan is correct before sending out any lender-specific documents, such as Landlord Subordination.'
    }
    return (
      <Container id="prepare_hellosign_modal">
        <Header>
          <Title>Prepare Document for E-Sign</Title>
          <Close onClick={toggleModal}>X</Close>
        </Header>
        <Body hasTemplate={Boolean(this.props.document.helloSignTemplateId)}>
          <SmallText id="instructionText" size="14px" color="inherit">
            {instructionText}
          </SmallText>
          {otherInstText && <br />}
          {otherInstText && <br />}
          {otherInstText && (
            <SmallText size="14px" color="inherit">
              <strong>Important: </strong>
              {otherInstText}
            </SmallText>
          )}
          {this.renderDocumentTypeSelection()}
          {this.props.document.helloSignTemplateId && <Line />}
          {this.renderCustomForm()}
          {this.renderSignersForm()}
          {documentType ? (
            <Footer>
              <Button
                disable={false}
                onClick={toggleModal}
                id="cancel_prepare_esign"
              >
                Cancel
              </Button>
              <Button
                style={
                  complete
                    ? { color: 'white', backgroundColor: '#DC6A00' }
                    : { color: 'white' }
                }
                disable={!complete}
                onClick={this.submitEsign}
                id="prepare_esign"
              >
                Prepare for signing
              </Button>
            </Footer>
          ) : null}
        </Body>
      </Container>
    )
  }
}

export { PrepareHelloSignModal }

const PrepareHelloSignModalWithQuery = compose(
  graphql(PrepareEsign, {
    name: 'prepareEsign',
  }),
  graphql(CreateSignatureRequests, {
    name: 'createSignatureRequests',
  }),
  graphql(HelloSignQuery, {
    name: 'helloSign',
  }),
)(PrepareHelloSignModal)

export default PrepareHelloSignModalWithQuery
